<div *ngIf="!sended && currentUser" class="bg-white mb-0 pb-1 pt-2">
  <div class="col-12">
    <div class="row">
      <div class="col-xl-1 col-12">
        <img class="m-lg-3" src="/assets/images/logo/logo-landing.svg" alt="Logo Nepta" />
      </div>
      <div class="col-xl-11 col-12">
        <h1 class="mt-lg-5 pt-lg-5" id="logo-written">
          {{ "LANDING.INSERT_DATA" | translate }}<br />
          {{ "LANDING.JOIN_GROUP" | translate }} <span class="text-primary">{{ "LANDING.TEAM_NAME" | translate }}</span>
        </h1>
        <img id="displays" src="/assets/images/illustration/displays.svg" alt="Displays" />
        <img id="people" src="/assets/images/illustration/landing-people.svg" alt="people" />
      </div>
    </div>
  </div>
</div>
<!----------------------------------FORM START---------->
<div *ngIf="!sended && currentUser" class="card pt-4 mb-0">
  <div class="container-md min-vh-100">
    <form class="row" [formGroup]="formGroup" *ngIf="currentUser">
      <div class="col-lg-6 col-12 order-lg-1 forms">
        <!----------------------------------FORM MASTERDATA START---------->
        <div class="row">
          <div class="col-12 mb-3">
            <h1>{{ "MASTERDATA" | translate }}</h1>
            <small>{{ "INSERT.ADD_GENERALITY" | translate }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-5 col-12">
            <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="firstname" (change)="calculateFiscalCode()" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_NAME" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="lastname" (change)="calculateFiscalCode()" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="sex">{{ "GENDER" | translate }}<sup class="text-danger">*</sup></label>
            <select name="sex" id="sex" (change)="calculateFiscalCode()" class="form-control {{ fieldHasErrors('sex') ? 'is-invalid' : '' }}" formControlName="sex">
              <option value="m">{{ "MAN" | translate }}</option>
              <option value="f">{{ "WOMAN" | translate }}</option>
              <option value="nb">{{ "NOT_BINARY" | translate }}</option>
              <option value="o">{{ "NOT_SPECIFIED" | translate }}</option>
            </select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_SEX" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="birth_place">{{ "BIRTH_PLACE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              formControlName="birth_place"
              id="birth_place"
              bindLabel="nice_name"
              *ngIf="type_nationality !== 'UE' && type_nationality !== 'Extra Ue'"
              bindValue="id"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="true"
              (change)="calculateFiscalCode()"
              [items]="_citiesService.list"
              [openOnEnter]="false"
              [virtualScroll]="true"
              class="{{ fieldHasErrors('birth_place') ? 'is-invalid' : '' }}"
            >
            </ng-select>
            <input class="form-control" type="text" readonly *ngIf="type_nationality === 'UE' || type_nationality === 'Extra Ue'" value="Altro ()" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_BIRTH_PLACE" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="birthday">{{ "BIRTHDAY" | translate }}<sup class="text-danger">*</sup></label>
            <input (change)="calculateFiscalCode()" type="date" id="birthday" [max]="eighteen_years_ago" class="form-control {{ fieldHasErrors('birthday') ? 'is-invalid' : '' }}" formControlName="birthday" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_BIRTHDAY" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="phone">{{ "PHONE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="tel" id="phone" class="form-control {{ fieldHasErrors('phone') ? 'is-invalid' : '' }}" formControlName="phone" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_PHONE" | translate }}</div>
          </div>
          <div class="form-group col-lg-10 col-12">
            <label for="email">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
            <input type="email" id="email" class="form-control {{ fieldHasErrors('email') ? 'is-invalid' : '' }}" formControlName="email" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_PRIVATE_EMAIL" | translate }}</div>
          </div>
        </div>
      </div>
      <!----------------------------------FORM MASTERDATA END---------->

      <!----------------------------------FORM DOCUMENTS START---------->
      <div class="col-lg-6 col-12 order-lg-2 order-3 forms">
        <div class="row">
          <div class="col-12 mb-3">
            <h1>{{ "ESSENTIAL_DOCUMENTS" | translate }}</h1>
            <small>{{ "INSERT.ADD_DOCUMENTS" | translate }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-5 col-12">
            <label for="fiscal_code">{{ "FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="fiscal_code" oninput="this.value = this.value.toUpperCase()" class="form-control {{ fieldHasErrors('fiscal_code') ? 'is-invalid' : '' }}" formControlName="fiscal_code" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_FISCAL_CODE" | translate }}</div>
            <small *ngIf="isFiscalCodeGenerate && formGroup.value.fiscal_code.length == 16" class="text-primary">{{ "ERRORS.CONTROL_FISCAL_CODE" | translate }}</small>
          </div>
          <div class="form-group col-lg-5 col-12">
            <fieldset>
              <label>{{ "LOAD_FISCAL_CODE" | translate }}<sup class="text-danger">*</sup></label>
              <div class="custom-file {{ !file_fiscal_code && showErrors ? 'border-danger' : null }}">
                <input class="custom-file-input" type="file" lang="it" id="file_fiscal_code" accept="application/pdf, image/jpg, image/jpeg" (change)="handlerChangeFileInput($event, 'fiscal-code')" />
                <label *ngIf="!fileNameFiscalCode" class="custom-file-label {{ !file_fiscal_code && showErrors ? 'border-danger' : null }}">{{ "SELECT_FILE" | translate }}</label>
                <label *ngIf="fileNameFiscalCode && fileNameFiscalCode.length > 0" class="custom-file-label text-break-line-1">{{ fileNameFiscalCode }}</label>
              </div>
            </fieldset>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="type_ue">{{ "DOCUMENT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              bindValue="value"
              bindLabel="name"
              id="type_ue"
              formControlName="document_type"
              class="{{ fieldHasErrors('document_type') ? 'is-invalid' : '' }}"
              [closeOnSelect]="true"
              [clearable]="false"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [items]="document_id_types"
            ></ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_TYPE_DOCUMENT" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="document_number">{{ "DOCUMENT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="document_number" formControlName="document_number" oninput="this.value = this.value.toUpperCase()" class="form-control {{ fieldHasErrors('document_number') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_DOCUMENT_NUMBER" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <label for="document_valid_until">{{ "DOCUMENT_EXPIRE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="date" id="document_valid_until" formControlName="document_valid_until" [min]="currenDate" class="form-control {{ fieldHasErrors('document_valid_until') ? 'is-invalid' : '' }}" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_DOCUMENT_EXPIRE" | translate }}</div>
          </div>
          <div class="form-group col-lg-5 col-12">
            <fieldset>
              <label for="document_id_front">{{ "INSERT.UPLOAD_DOCUMENT" | translate }}<sup class="text-danger">*</sup></label>
              <div class="custom-file {{ !file_document_id && showErrors ? 'border-danger' : null }}">
                <input class="custom-file-input" type="file" lang="it" id="document_id_front" accept="application/pdf, image/jpg, image/jpeg" (change)="handlerChangeFileInput($event, 'document-id')" />
                <label *ngIf="!fileNameDocument" class="custom-file-label {{ !file_document_id && showErrors ? 'border-danger' : null }}">{{ "SELECT_FILE" | translate }}</label>
                <label *ngIf="fileNameDocument && fileNameDocument.length > 0" class="custom-file-label text-break-line-1">{{ fileNameDocument }}</label>
              </div>
            </fieldset>
          </div>

          <!--RESIDENCE PERMIT NUMBER -->
          <ng-container *ngIf="type_nationality === 'Extra Ue'">
            <div class="form-group col-lg-5 col-12">
              <label for="document_residence_permit_number">{{ "RESIDENCE_PERMIT_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
              <input
                type="text"
                id="document_residence_permit_number"
                class="form-control {{ fieldHasErrors('document_residence_permit_number') ? 'is-invalid' : '' }}"
                formControlName="document_residence_permit_number"
              />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_DOCUMENT_NUMBER" | translate }}</div>
            </div>
            <div class="form-group col-lg-5 col-12">
              <label for="document_residence_permit_valid_until">{{ "RESIDENCE_PERMIT_VALID_UNTIL" | translate }}<sup class="text-danger">*</sup></label>
              <input
                type="date"
                id="document_residence_permit_valid_until"
                [min]="currenDate"
                class="form-control {{ fieldHasErrors('document_residence_permit_valid_until') ? 'is-invalid' : '' }}"
                formControlName="document_residence_permit_valid_until"
              />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_DOCUMENT_EXPIRE" | translate }}</div>
            </div>
            <div class="form-group col-lg-10 col-12">
              <label for="document_id_front">{{ "INSERT.UPLOAD_PERMIT_DOCUMENT" | translate }}<sup class="text-danger">*</sup></label>
              <div class="custom-file {{ !file_permit && showErrors ? 'border-danger' : null }}">
                <input class="custom-file-input" type="file" lang="it" id="residence_permit_url" accept="application/pdf, image/jpg, image/jpeg" (change)="handlerChangeFileInput($event, 'residence_permit')" />
                <label *ngIf="!fileNameDocumentPermit" class="custom-file-label {{ !file_permit && showErrors ? 'border-danger' : null }}">{{ "SELECT_FILE" | translate }}</label>
                <label *ngIf="fileNameDocumentPermit && fileNameDocumentPermit.length > 0" class="custom-file-label text-break-line-1">{{ fileNameDocumentPermit }}</label>
              </div>
            </div>
          </ng-container>
          <div class="col-12 d-flex justify-content-end mt-5 mb-1">
            <button (click)="save()" type="submit" class="btn btn-primary ml-1">{{ "SEND" | translate }}</button>
          </div>
        </div>
        <!----------------------------------FORM DOCUMENTS END---------->
      </div>

      <!----------------------------------FORM RESIDENCE START---------->
      <div class="col-lg-6 col-12 order-lg-3 mb-2 forms">
        <div class="row">
          <div class="col-12 mb-3">
            <h1>{{ "RESIDENCE_INFORMATION" | translate }}</h1>
            <small>{{ "INSERT.ADD_RESIDENCE" | translate }}</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6 col-12">
            <label for="type_nationality">{{ "TYPE_NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              (change)="setCountry()"
              id="type_nationality"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="type_nationality"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="!!type_nationality"
              [openOnEnter]="false"
              [virtualScroll]="true"
              class="{{ !type_nationality && showErrors ? 'border-danger' : null }}"
            >
              <ng-option value="Italiana">{{ "ITALIAN" | translate }}</ng-option>
              <ng-option value="UE">UE</ng-option>
              <ng-option value="Extra Ue">Extra UE</ng-option>
            </ng-select>
            <div class="text-danger font-small-3" *ngIf="!type_nationality && showErrors">{{ "ERRORS.INSERT_TYPE_NATIONALITY" | translate }}</div>
          </div>
          <div class="form-group col-lg-6 col-12">
            <label for="nationality">{{ "NATIONALITY" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              id="nationality"
              class="{{ fieldHasErrors('residence_nationality') ? 'is-invalid' : '' }}"
              formControlName="residence_nationality"
              (change)="calculateFiscalCode()"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="!!formGroup.value.residence_nationality"
              [openOnEnter]="false"
              [virtualScroll]="true"
            >
              <ng-option *ngFor="let nationality of nationalities_list" [value]="nationality">{{ nationality }}</ng-option>
            </ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_NATIONALITY" | translate }}</div>
          </div>
          <div class="form-group col-lg-6 col-12">
            <label for="residence_street">{{ "ADDRESS_STREET" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="residence_street" class="form-control {{ fieldHasErrors('residence_street') ? 'is-invalid' : '' }}" formControlName="residence_street" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
          </div>
          <div class="form-group col-lg-6 col-12">
            <label for="residence_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
            <input type="text" id="residence_zipcode" class="form-control {{ fieldHasErrors('residence_zipcode') ? 'is-invalid' : '' }}" formControlName="residence_zipcode" />
            <div class="invalid-feedback">{{ "ERRORS.INSERT_ZIP_CODE" | translate }}</div>
          </div>
          <div class="form-group col-lg-6 col-12">
            <label for="residence_city">{{ "CITY" | translate }}/{{ "REGION" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              id="residence_city"
              bindLabel="nice_name"
              bindValue="id"
              class="{{ fieldHasErrors('residence_city') ? 'is-invalid' : '' }}"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="true"
              [items]="_citiesService.listWithoutItaly"
              [openOnEnter]="false"
              [virtualScroll]="true"
              (change)="setAutoProvince('residence')"
              formControlName="residence_city"
            >
            </ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_CITY_REQUIRED" | translate }}</div>
          </div>
          <div class="form-group col-lg-6 col-12 mb-4">
            <label for="residence_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select
              formControlName="residence_province"
              id="residence_province"
              bindLabel="name"
              bindValue="id"
              class="{{ fieldHasErrors('residence_province') ? 'is-invalid' : '' }}"
              [searchable]="true"
              [closeOnSelect]="true"
              [clearable]="true"
              [openOnEnter]="false"
              [virtualScroll]="true"
              [items]="_citiesService.list"
            >
            </ng-select>
            <div class="invalid-feedback">{{ "ERRORS.INSERT_PROVINCE" | translate }}</div>
          </div>
        </div>
      </div>
      <!----------------------------------FORM RESIDENCE END---------->
    </form>
  </div>
  <div class="row">
    <div class="col-12">
      <img class="magnifying-woman" src="/assets/images/illustration/woman-magnifying.svg" alt="woman-illustration" />
    </div>
  </div>
</div>
<!----------------------------------FORM END---------->
<div *ngIf="sended" id="thank-you">
  <div>
    <h2>{{ "THANKYOU_FOR_DATA" | translate }}</h2>
    <p>
      {{ "WE_WILL_WRITE_TO_YOU_1" | translate }} <strong>{{ "WE_WILL_WRITE_TO_YOU_2" | translate }}</strong>
    </p>
  </div>
</div>
